export const fileHelper = {
    toBase64: (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });
    },

    getRawBase64: (fullBase64: string): string => {
        if (fullBase64.includes(',')) {
            return fullBase64.split(',')[1];
        }
        return fullBase64;
    },

    formatSrc: (base64String: string): string => {
        if (!base64String) return "/image/user_placeholder.png";
        if (base64String.startsWith('data:')) return base64String;
        return `data:image/png;base64,${base64String}`;
    },

    compressImage: (file: File, quality = 0.7): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target?.result as string;
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");
                    const MAX_WIDTH = 800;
                    let width = img.width;
                    let height = img.height;

                    if (width > MAX_WIDTH) {
                        height = Math.round(height * (MAX_WIDTH / width));
                        width = MAX_WIDTH;
                    }

                    canvas.width = width;
                    canvas.height = height;

                    if (ctx) {
                        ctx.fillStyle = "#FFFFFF";
                        ctx.fillRect(0, 0, width, height);
                        ctx.drawImage(img, 0, 0, width, height);
                        const compressedBase64 = canvas.toDataURL("image/jpeg", quality);
                        resolve(compressedBase64);
                    } else {
                        reject(new Error("Erro ao criar canvas"));
                    }
                };
            };
            reader.onerror = (error) => reject(error);
        });
    },


    toMultipartFormData: (file: File, keyName: string = "file"): FormData => {
        const formData = new FormData();
        formData.append(keyName, file);
        return formData;
    }
};